import React, { useCallback, useEffect, useRef, useState } from "react";
import filter from "../assets/images/filter.png";
import exportPic from "../assets/images/export.png";
import CreatePost from "../components/FeedManagement/CreatePost";
import ViewPost from "../components/FeedManagement/ViwePost";
import DeletePost from "../components/FeedManagement/DeletePost";
import {
  deleteFeed,
  getFeed,
  pinnedFeed,
} from "../features/slices/feedmanagement";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment/moment";
import CommonPagination from "../components/CommonPagination";
import ExportToExcel from "../components/ExportToExcel";
import { toastService } from "../utils/toastify";
import CommentListModal from "../components/FeedManagement/CommentListModal";
import TableSkeleton from "../components/TableSkeleton";
import { getEmail } from "../utils/getToken";
import { canPerformAction, denyAccess } from "../utils/denyAccess";

const initialState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
  showCreatePost: false,
  showPost: false,
  deletePost: false,
  commentList: false,
  is_pinned: "",
  filterStatus: "",
};

const FeedManagement = () => {
  const [iState, setUpdateState] = useState(initialState);
  const {
    searchQuery,
    fromDate,
    toDate,
    timeframe,
    status,
    showCreatePost,
    showPost,
    deletePost,
    commentList,
    is_pinned,
    filterStatus,
  } = iState;
  const [id, setId] = useState(null);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const { feeds, loading } = useSelector((state) => state?.feed);
  const feedRef = useRef();
  const handleShow = (name, id) => {
    setUpdateState({
      ...iState,
      [name]: true,
    });
    setId(id);
  };
  const handleTimeFrame = (e) => {
    const queryParams = { timeframe: e.target.value };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getFeed(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };
  useEffect(() => {
    dispatch(getFeed({ page }));
    window.scrollTo(0, 0);
  }, [page]);

  const handleCommentList = (postId) => {
    setId(postId);
    setUpdateState((prev) => ({
      ...prev,
      commentList: true,
    }));
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getFeed({ page }));
  };
  const handleDelete = (reason) => {
    dispatch(
      deleteFeed({
        id,
        status: "DELETED",
        deleteReason: reason,
      })
    ).then((res) => {
      if (res?.payload?.code == 200) {
        dispatch(getFeed({ page }));
        handleClose();
      } else {
        toastService.error(res?.payload?.message);
      }
    });
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deletePost: false,
    }));
  };
  const pinManagement = (id, status) => {
    dispatch(
      pinnedFeed({
        id: id,
        is_pinned: status,
      })
    ).then((res) => {
      if (res?.payload?.code == 200) {
        status == true
          ? toastService.success("Pinned successfully")
          : toastService.success("unPinned successfully");
        dispatch(getFeed({ page, search: searchQuery?.trim() }));
      } else {
        toastService.error(res?.payload?.message);
      }
    });
  };
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getFeed(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   searchQuery: "",
        //   fromDate: "",
        //   toDate: "",
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleFilter = (e) => {
    const status = e.target.value;
    setUpdateState((prev) => ({
      ...prev,
      status: status,
    }));
    if (status == "pin") {
      setUpdateState((prev) => ({
        ...prev,
        is_pinned: true,
      }));
      dispatch(
        getFeed({
          is_pinned: true,
          search: searchQuery?.trim(),
        })
      );
    } else if (status == "unpin") {
      dispatch(
        getFeed({
          is_pinned: false,
        })
      );
    } else {
      setUpdateState((prev) => ({
        ...prev,
        filterStatus: status,
      }));
      dispatch(
        getFeed({
          userType: status,
          search: searchQuery?.trim(),
        })
      );
    }
  };
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getFeed({
            search: searchQuery?.trim(),
            is_pinned,
            status: filterStatus,
          })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const UserData = getEmail("adminLogin");
  const handleCommentClose = useCallback(() => {
    return setUpdateState((prev) => ({
      ...prev,
      commentList: false,
    }));
  }, []);
  console.log({ UserData });

  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="FilterArea">
            <div className="form-group">
              <label>From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                disabled={timeframe}
                name="fromDate"
                onChange={(e) => handleSearch(e)}
              />
            </div>
            <div className="form-group">
              <label>To Date</label>
              <input
                type="date"
                className="form-control"
                name="toDate"
                value={toDate}
                disabled={timeframe}
                onChange={(e) => handleSearch(e)}
              />
            </div>
            <div className="form-group">
              <label>&nbsp;</label>
              <button className="Button" onClick={handleSubmit}>
                Apply
              </button>
            </div>
            <div className="form-group">
              <label>Timeframe</label>
              <select
                className="form-control customSelect"
                name="timeframe"
                value={timeframe}
                disabled={fromDate || toDate}
                onChange={(e) => handleTimeFrame(e)}
              >
                <option value="" hidden>
                  Select
                </option>
                <option value="Today">Today</option>
                <option value="Week">This Week</option>
                <option value="Month">This Month</option>
              </select>
            </div>

            {canPerformAction("Feed") && (
              <div className="TitleBox m-0">
                <label>&nbsp;</label>
                <a
                  className="TitleLink"
                  onClick={() =>
                    setUpdateState((prev) => ({
                      ...prev,
                      showCreatePost: true,
                    }))
                  }
                >
                  <i className="fa-solid fa-plus" /> Create Post
                </a>
              </div>
            )}
          </div>
          <div className="Small-Wrapper">
            <div className="NewFilter">
              <div
                className="SearchBox"
                style={{
                  width: "60%",
                }}
              >
                <input
                  type="search"
                  className="SearchInput"
                  placeholder="Search here by ID, Name, or Others"
                  name="searchQuery"
                  value={searchQuery}
                  onChange={(e) => handleSearch(e)}
                />
                <span>
                  <i className="fa fa-search" />
                </span>
              </div>

              <div className="Actions">
                <div
                  className="form-group"
                  style={{
                    textAlign: "center",
                  }}
                >
                  <select
                    className="form-control FilterStatus"
                    name="status"
                    value={status}
                    onChange={(e) => handleFilter(e)}
                  >
                    <option value="" disabled hidden>
                      Filter by Status
                    </option>
                    <option value="USER">User</option>
                    <option value="ADMIN">Admin</option>
                    <option value="pin">PIN</option>
                    {/* <option value="unpin">Unpin</option> */}
                  </select>
                </div>
                <button className="Button Cancel" onClick={handleReset}>
                  <i className="fa fa-refresh" />
                </button>
                <ExportToExcel ref={feedRef} fileName="feeds" />
              </div>
            </div>
            <div className="TableList">
              <table className="table-hover" ref={feedRef}>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Post ID</th>
                    <th>Posted By</th>
                    <th>Date &amp; Time of Post</th>
                    <th>No of Likes</th>
                    <th>No of Comments</th>
                    {/* <th>Status</th> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!loading ? (
                    feeds?.result?.[0]?.paginationData.map((data, i) => {
                      return (
                        <tr key={data?._id}>
                          <td>{i + 1 + (page - 1) * 10}</td>
                          <td>{data?.post_number}</td>
                          <td>
                            <div className="fw500">
                              {data?.userData?.fullName ||
                                UserData?.name ||
                                "Admin"}
                            </div>
                          </td>
                          <td>
                            {moment(data?.createdAt).format(
                              "DD-MM-YYYY, h:mm "
                            )}
                          </td>
                          <td>{data?.likeCount}</td>
                          <td>
                            <a
                              className="BlueLink"
                              onClick={() => handleCommentList(data?._id)}
                            >
                              {data?.commentCount}
                            </a>
                          </td>
                          {/* <td>
                            <span className="Green">
                              {data?.status == "ACTIVE"
                                ? "Available"
                                : "Removed"}
                            </span>
                          </td> */}
                          <td>
                            <div className="Actions">
                              <a
                                className="Eyes"
                                onClick={() =>
                                  handleShow("showPost", data?._id)
                                }
                              >
                                <i className="fa-regular fa-eye" />
                              </a>
                              {canPerformAction("Feed") && (
                                <>
                                  <a
                                    className={`${
                                      data?.is_pinned == false
                                        ? "Delete"
                                        : "Filter"
                                    }`}
                                    onClick={() =>
                                      pinManagement(
                                        data?._id,
                                        data?.is_pinned === false ? true : false
                                      )
                                    }
                                  >
                                    <img
                                      src={require("../assets/images/pin.png")}
                                    />
                                  </a>
                                  <a
                                    className="Delete"
                                    onClick={() =>
                                      handleShow("deletePost", data?._id)
                                    }
                                  >
                                    <i className="fa-regular fa-trash-can" />
                                  </a>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <TableSkeleton
                      length={feeds?.result?.[0]?.paginationData?.length}
                    />
                  )}
                </tbody>
              </table>
            </div>
            <div className="Pagination">
              {feeds?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <>
                  <p>
                    Showing {(page - 1) * 10 + 1} to{" "}
                    {feeds?.result?.[0]?.paginationData?.length +
                      (page - 1) * 10}{" "}
                    of {feeds?.result?.[0]?.totalCount?.[0]?.count} results
                  </p>
                  <div className="PaginationRight">
                    <CommonPagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        feeds?.result?.[0]?.totalCount?.[0]?.count || 0
                      }
                      pageRangeDisplayed={4}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {showCreatePost && <CreatePost setUpdateState={setUpdateState} />}
      {showPost && <ViewPost setUpdateState={setUpdateState} postId={id} />}
      {deletePost && (
        <DeletePost
          setUpdateState={setUpdateState}
          handleDelete={handleDelete}
        />
      )}
      {commentList && (
        <CommentListModal handleCommentClose={handleCommentClose} id={id} />
      )}
    </>
  );
};

export default FeedManagement;
